(function () {
  function attachVideoControls(deferredMedia) {
    const video = deferredMedia.querySelector('video');
    if (!video || deferredMedia.dataset.videoControlsAttached) return;
    deferredMedia.dataset.videoControlsAttached = 'true';

    video.addEventListener('play', () => {
      deferredMedia.classList.remove('is-paused');
    });

    video.addEventListener('pause', () => {
      deferredMedia.classList.add('is-paused');
    });

    video.addEventListener('ended', () => {
      deferredMedia.classList.add('is-paused');
    });

    const poster = deferredMedia.querySelector('[id^="Deferred-Poster-"]');
    if (poster) {
      poster.addEventListener('click', () => {
        if (deferredMedia.hasAttribute('loaded')) {
          video.play();
        }
      });
    }
  }

  function observeDeferredMedia() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'loaded' &&
          mutation.target.hasAttribute('loaded')
        ) {
          attachVideoControls(mutation.target);
        }
      });
    });

    document.querySelectorAll('deferred-media').forEach((el) => {
      observer.observe(el, { attributes: true, attributeFilter: ['loaded'] });
      if (el.hasAttribute('loaded')) attachVideoControls(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDeferredMedia);
  } else {
    observeDeferredMedia();
  }
})();
